const LOOKUP_BASE_URL = '/api/service_lookup';

export const LOOKUP_URLS = Object.freeze({
  PROGRESS: `${LOOKUP_BASE_URL}/ot_session_progresses`,
  BEHAVIOR: `${LOOKUP_BASE_URL}/ot_session_behaviors`,
  OBJECTIVE: `${LOOKUP_BASE_URL}/ot_session_objectives`,
  IMPLEMENTATION: `${LOOKUP_BASE_URL}/ot_session_objective_implementation`,
  ASSIST_TYPE: `${LOOKUP_BASE_URL}/ot_session_assist_type`
});

/** App table values referenced within FE. */
export const CODES = Object.freeze({
  OTHER: 'OTHER'
});

export const GROUP_TYPE = Object.freeze({
  GROUP: 'GROUP'
});



// WEBPACK FOOTER //
// ./src/constants/service-log.js